export interface EnterSubmitDecisionInput {
  key: string;
  shiftKey: boolean;
  isComposing: boolean;
  keyCode?: number;
  prefersTouchInput: boolean;
}

export function detectTouchInput(): boolean {
  if (typeof window === 'undefined') return false;
  const supportsHoverFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const prefersCoarseTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  const maxTouchPoints = navigator.maxTouchPoints ?? 0;
  return prefersCoarseTouch || (maxTouchPoints > 0 && !supportsHoverFine);
}

export function shouldSubmitOnEnter(input: EnterSubmitDecisionInput): boolean {
  if (input.key !== 'Enter') return false;
  if (input.shiftKey) return false;
  if (input.prefersTouchInput) return false;
  if (input.isComposing || input.keyCode === 229) return false;
  return true;
}
